/* eslint-disable no-underscore-dangle */
import axios from 'axios'
import storage from 'reduxjs-toolkit-persist/lib/storage'
import { env } from '../../utils/constants/env-vars'
import { endpointsAuth } from '../endpoints'
import TokenService from '../token.service'

const API = axios.create({
  baseURL: env.URL_BACK,
})

API.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken()
    if (token) {
      config.headers.Authorization = 'Bearer ' + token // for Spring Boot back-end
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)

API.interceptors.response.use(
  (res) => {
    return res
  },
  async (err) => {
    const originalConfig = err.config
    if (originalConfig?.url !== endpointsAuth.LOGIN && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true
        try {
          const refreshToken = TokenService.getLocalRefreshToken()
          if (refreshToken === null) {
            window.location.href = '/login'
            return null
          }
          const rs = await API.post(endpointsAuth.REFRESH_TOKEN, {
            refreshToken,
          })
          const { accessToken } = rs.data.resp
          TokenService.updateLocalAccessToken(accessToken)
          return API(originalConfig)
        } catch (_error) {
          TokenService.removeJWT()
          storage.removeItem('persist:root')
          window.location.href = '/login'
          return Promise.reject(_error)
        }
      }
    }
    if (originalConfig.url === endpointsAuth.REFRESH_TOKEN && err.response) {
      window.location.href = '/login'
      return null
    }
    return Promise.reject(err)
  },
)

export default API
